import useInvoicesTable from "./useInvoicesTable"
import Table from "./Table"
import PropTypes from "prop-types";

/**
 * @param {Object} props
 * @param {'electricity' | 'gas'} props.type
 * @param {boolean} [props.sortEnabled]
 */
const InvoicesTable = ({ type, sortEnabled }) => {
  const { invoices, columns, loaded } = useInvoicesTable({type});

  return (
    <Table
      columns={columns}
      loaded={loaded}
      data={invoices}
      sortEnabled={sortEnabled}
    />
  )
}

InvoicesTable.propTypes = {
  type: PropTypes.oneOf(/** @type {const} */ (['electricity', 'gas'])).isRequired,
  sortEnabled: PropTypes.bool,
}

export default InvoicesTable;